import React, { useEffect, useState } from 'react';

// Multi-step reasoning + SQL execution over large tables can legitimately
// run well past what feels instant. Rather than let a long wait read as
// "stuck," swap the label after a while so the user knows it's still going.
const STILL_WORKING_AFTER_MS = 18000;

export default function TypingIndicator() {
  const [stillWorking, setStillWorking] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setStillWorking(true), STILL_WORKING_AFTER_MS);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={s.wrap} aria-live="polite" aria-label="Assistant is thinking">
      <div style={s.avatar} aria-hidden="true">
        <span style={s.avatarGlyph}>AI</span>
      </div>
      <div style={s.bubble}>
        <span style={s.label}>{stillWorking ? 'Still working — this can take a bit for larger datasets…' : 'Thinking...'}</span>
        <div style={s.dots}>
          {[0, 1, 2].map(i => (
            <span key={i} style={{ ...s.dot, animationDelay: `${i * 0.18}s` }} />
          ))}
        </div>
      </div>
    </div>
  );
}

const s = {
  wrap: { display: 'flex', gap: 12, marginBottom: 20, alignItems: 'flex-start', animation: 'fadeIn 0.25s ease' },
  avatar: {
    width: 34, height: 34, borderRadius: 12, background: 'var(--bg-tertiary)',
    display: 'flex', alignItems: 'center',
    justifyContent: 'center', color: 'var(--accent)', fontWeight: 700, fontSize: 14, flexShrink: 0,
  },
  avatarGlyph: { fontSize: 11, fontWeight: 800, letterSpacing: '0.5px' },
  bubble: {
    background: 'var(--bg-secondary)',
    borderRadius: 16, borderBottomLeftRadius: 4, padding: '10px 16px',
    display: 'flex', alignItems: 'center', gap: 10,
  },
  label: { fontSize: 12, color: 'var(--text-secondary)', fontWeight: 600 },
  dots: { display: 'flex', gap: 5, alignItems: 'center' },
  dot: {
    width: 7, height: 7, borderRadius: '50%', background: 'var(--accent)',
    animation: 'typing 1.1s ease-in-out infinite',
    display: 'inline-block',
  },
};
